import { getToken } from 'firebase/app-check';
import { appCheck } from '../services/firebase';

/**
 * fetch() wrapper that attaches an X-Firebase-AppCheck header so requests
 * survive backend `enforceAppCheck: true` on public HTTP Cloud Functions.
 *
 * Use this for any direct HTTP call to a Cloud Function that has App Check
 * enforcement enabled (validateInvitationToken, onboardParent/Teacher,
 * createSignatureHttp, generatePDF, enrollFamily, etc.). Failure to attach
 * the header causes a silent 401 → user-visible "invalid invitation"
 * regression (production incident 2026-04-25).
 *
 * App Check token retrieval failures are logged but do not block the request,
 * so dev/test environments without reCAPTCHA still work — the backend will
 * decide whether to reject.
 */
export async function appCheckedFetch(
  url: string,
  options: RequestInit = {},
): Promise<Response> {
  let token = '';
  if (appCheck) {
    try {
      const result = await getToken(appCheck);
      token = result.token;
    } catch (err) {
      console.warn('App Check token fetch failed', err);
    }
  }
  const baseHeaders: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  return fetch(url, {
    ...options,
    headers: {
      ...baseHeaders,
      ...(options.headers as Record<string, string> | undefined),
      ...(token ? { 'X-Firebase-AppCheck': token } : {}),
    },
  });
}
